module.exports = __webpack_public_path__ + "img/thumb-equipe.fcc9a981.jpg";